import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OrderStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('OrderStatusReference');
  }
}
